module.exports = __webpack_public_path__ + "img/partnership_plan_desc_03.7517f0c4.png";